import { jsx } from "react/jsx-runtime";
import { styled, IconButton } from "@mui/material";
import { CloseIcon } from "../../icons/24/Action/Close.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
import { spreadSx } from "../../utils/spreadSx.js";
import { CLEAR_BUTTON_CLASSNAME } from "../InputControl/Input/InputBase.js";
import cn from "../../vendor/classnames/index.js";
import { iconSizeMap } from "./Common.js";
const sizeStyles = {
  button: {
    sm: {
      width: 24 + 3 * 2,
      height: "100%"
    },
    md: {
      width: 30 + 6 * 2,
      height: "100%"
    },
    lg: {
      width: 42 + 9 * 2,
      height: "100%"
    }
  }
}, TimesButton = ({
  onClick,
  size,
  sx,
  ...props
}) => /* @__PURE__ */ jsx(
  GreyButton,
  {
    className: cn(CLEAR_BUTTON_CLASSNAME, props.className),
    "data-test-id": DATA_TEST_ID_INHERITED,
    sx: [
      { position: "absolute", top: 0, right: 0, visibility: "hidden" },
      sizeStyles.button[size],
      ...spreadSx(sx)
    ],
    onClick,
    ...props,
    children: /* @__PURE__ */ jsx(CloseIcon, { size: iconSizeMap[size] })
  }
), GreyButton = styled(IconButton)(({ theme: t }) => ({
  padding: 0,
  path: {
    fill: t.palette.grey[400]
  },
  "@media (hover: hover)": {
    "&:hover": {
      path: {
        fill: t.palette.grey[500]
      }
    }
  },
  "&:active": {
    path: {
      fill: t.palette.grey[700]
    }
  },
  "&:disabled": {
    path: {
      fill: t.palette.grey[400]
    }
  }
}));
export {
  GreyButton,
  TimesButton
};
//# sourceMappingURL=TimesButton.js.map
